/**
 * Scroll fade - opacity driven directly by scroll position.
 *
 * Reads 4 parameters per element from data attributes (set in
 * snippets/animate-scroll-text.liquid): opacity-start, opacity-end,
 * position-start, position-end. Position values are a percentage of
 * viewport height measured from the top (0 = top of viewport, 100 = bottom).
 *
 * Deliberately self-contained and independent from the theme's xo-animate
 * system - no external dependencies, so its behavior is fully predictable
 * and doesn't rely on a third-party bundle's internal easing.
 */
(function () {
  var elements = [];
  var ticking = false;

  function collectElements() {
    elements = Array.prototype.slice.call(document.querySelectorAll('[data-scroll-fade]'));
  }

  function update() {
    var viewportHeight = window.innerHeight;

    elements.forEach(function (el) {
      var opacityStart = parseFloat(el.getAttribute('data-opacity-start'));
      var opacityEnd = parseFloat(el.getAttribute('data-opacity-end'));
      var positionStart = parseFloat(el.getAttribute('data-position-start'));
      var positionEnd = parseFloat(el.getAttribute('data-position-end'));

      if (isNaN(opacityStart) || isNaN(opacityEnd) || isNaN(positionStart) || isNaN(positionEnd)) {
        return;
      }

      var rect = el.getBoundingClientRect();
      // Element's top edge position as a % of viewport height (0 = top, 100 = bottom)
      var currentPosition = (rect.top / viewportHeight) * 100;

      // Progress: 0 at positionStart, 1 at positionEnd. positionStart is
      // normally the larger number (further down/later in scroll, e.g. 90)
      // and positionEnd the smaller one (earlier, e.g. 50), since the
      // element's on-screen position decreases as the page scrolls down.
      var range = positionStart - positionEnd;
      var progress;
      if (range === 0) {
        progress = currentPosition <= positionEnd ? 1 : 0;
      } else {
        progress = (positionStart - currentPosition) / range;
      }
      progress = Math.max(0, Math.min(1, progress));

      var opacity = opacityStart + (opacityEnd - opacityStart) * progress;
      el.style.opacity = opacity;
    });

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  function init() {
    collectElements();
    if (elements.length === 0) return;
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor swaps section HTML in without a full page reload - rescan
  // so newly added/edited scroll-fade elements pick up the listener.
  document.addEventListener('shopify:section:load', function () {
    collectElements();
    update();
  });
})();
